/**
 * Pricing plans: supports pre-structured HTML (see pricing-plans-cms-snippet.html)
 * or flat CMS markup (h4 + ul + hr + h5 + p) which gets rebuilt on load.
 */
function formatPriceLine(element, valueClass, noteClass) {
  if (!element || element.querySelector(`.${valueClass}`)) {
    return;
  }

  const text = (element.textContent || '').replace(/\u00a0/g, ' ').trim();
  const match = text.match(/^(\$[\d,]+)\s*(.*)$/i);

  if (!match) {
    return;
  }

  element.innerHTML = '';
  const value = document.createElement('span');
  value.className = valueClass;
  value.textContent = match[1];
  element.appendChild(value);

  if (match[2]) {
    const note = document.createElement('span');
    note.className = noteClass;
    note.textContent = match[2].trim();
    element.appendChild(note);
  }
}

function enhanceExistingCards(container) {
  container.querySelectorAll('.pricing-plans__card').forEach((card, index) => {
    if (!card.querySelector('.pricing-plans__badge') && card.classList.contains('pricing-plans__card--featured')) {
      const badge = document.createElement('span');
      badge.className = 'pricing-plans__badge';
      badge.textContent = 'Popular';
      card.insertBefore(badge, card.firstChild);
    }

    card.querySelectorAll('.pricing-plans__price, h4').forEach((node) => {
      if (node.classList.contains('pricing-plans__title')) {
        return;
      }
      if (!node.classList.contains('pricing-plans__price')) {
        node.classList.add('pricing-plans__price');
      }
      formatPriceLine(node, 'pricing-plans__price-value', 'pricing-plans__price-note');
    });

    card.querySelectorAll('.pricing-plans__footer-amount, .pricing-plans__footer p').forEach((node) => {
      formatPriceLine(node, 'pricing-plans__deposit-value', 'pricing-plans__deposit-note');
    });

    if (index === 0 && !card.classList.contains('pricing-plans__card--standard')) {
      card.classList.add('pricing-plans__card--standard');
    }
    if (index === 1 && !card.classList.contains('pricing-plans__card--featured')) {
      card.classList.add('pricing-plans__card--featured');
    }
  });
}

function buildCardsFromFlatMarkup(container) {
  const uls = [...container.querySelectorAll(':scope > ul')];

  uls.forEach((ul, index) => {
    const headerNodes = [];
    let prev = ul.previousElementSibling;
    while (prev && (prev.tagName === 'H4' || prev.tagName === 'H3')) {
      headerNodes.unshift(prev);
      prev = prev.previousElementSibling;
    }

    const footerNodes = [];
    let next = ul.nextElementSibling;
    if (next && next.tagName === 'HR') {
      footerNodes.push(next);
      next = next.nextElementSibling;
    }
    if (next && next.tagName === 'H5') {
      footerNodes.push(next);
      next = next.nextElementSibling;
    }
    if (next && next.tagName === 'P') {
      footerNodes.push(next);
    }

    const card = document.createElement('div');
    card.className =
      index === 0
        ? 'pricing-plans__card pricing-plans__card--standard'
        : 'pricing-plans__card pricing-plans__card--featured';

    if (index === 1) {
      const badge = document.createElement('span');
      badge.className = 'pricing-plans__badge';
      badge.textContent = 'Popular';
      card.appendChild(badge);
    }

    const header = document.createElement('div');
    header.className = 'pricing-plans__header';

    headerNodes.forEach((node, i) => {
      if (i === 0) {
        node.classList.add('pricing-plans__title');
        if (node.tagName === 'H4') {
          const title = document.createElement('h3');
          title.className = 'pricing-plans__title';
          title.innerHTML = node.innerHTML;
          header.appendChild(title);
          node.remove();
        } else {
          header.appendChild(node);
        }
        return;
      }

      const price = document.createElement('div');
      price.className = 'pricing-plans__price';
      price.innerHTML = node.innerHTML;
      formatPriceLine(price, 'pricing-plans__price-value', 'pricing-plans__price-note');
      node.remove();
      header.appendChild(price);
    });

    const features = document.createElement('div');
    features.className = 'pricing-plans__features';
    features.appendChild(ul);

    const footer = document.createElement('div');
    footer.className = 'pricing-plans__footer';
    footerNodes.forEach((node) => {
      if (node.tagName === 'H5') {
        node.classList.add('pricing-plans__footer-label');
      }
      if (node.tagName === 'P') {
        node.classList.add('pricing-plans__footer-amount');
        formatPriceLine(node, 'pricing-plans__deposit-value', 'pricing-plans__deposit-note');
      }
      footer.appendChild(node);
    });

    const insertBefore = headerNodes[0] || ul;
    container.insertBefore(card, insertBefore);
    card.appendChild(header);
    card.appendChild(features);
    card.appendChild(footer);
  });
}

export function structurePricingPlans(root) {
  if (!root) return;

  const containers = [];
  if (root.classList.contains('pricing-plans')) {
    containers.push(root);
  }
  root.querySelectorAll('.pricing-plans').forEach((el) => {
    if (!containers.includes(el)) {
      containers.push(el);
    }
  });

  containers.forEach((container) => {
    if (container.dataset.pricingPlansStructured === 'true') {
      return;
    }

    if (container.querySelector('.pricing-plans__card')) {
      enhanceExistingCards(container);
    } else {
      buildCardsFromFlatMarkup(container);
    }

    container.dataset.pricingPlansStructured = 'true';
  });
}
